import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withTranslate from 'containers/widgets/withTranslate';
import Icon, { IconSizes, IconVariants } from 'components/foundations/Icon';
import css from './SectionsSidebar.css';

const SectionsSidebar = ({ sections, answeredBySectionId, activeSectionId, onSectionClick, translate }) => (
    <div className={css.sidebar}>
        <div className={css.title}>{translate('STATIC.PAGES.AI_CONTEXT.SECTIONS_TITLE')}</div>
        <div className={css.list}>
            {sections.map(section => {
                const isActive = section.id === activeSectionId;
                return (
                    <div
                        key={section.id}
                        className={classNames(css.item, { [css.active]: isActive })}
                        onClick={() => onSectionClick(section.id)}
                    >
                        <Icon
                            name={section.icon}
                            size={IconSizes.SMALL}
                            variant={isActive ? IconVariants.ACTIVE : IconVariants.LIGHT}
                            interactive={false}
                            className={css.icon}
                        />
                        <div className={css.name}>{translate(section.name)}</div>
                        <div className={css.counter}>
                            {answeredBySectionId[section.id]}/{section.questions.length}
                        </div>
                    </div>
                );
            })}
        </div>
    </div>
);

SectionsSidebar.propTypes = {
    sections: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            icon: PropTypes.string.isRequired,
            questions: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string.isRequired })).isRequired,
        })
    ).isRequired,
    answeredBySectionId: PropTypes.objectOf(PropTypes.number).isRequired,
    activeSectionId: PropTypes.string,
    onSectionClick: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default withTranslate(SectionsSidebar);
